export const getFields = (from, to, params) => {
  const elements = [
    {
      label: 'From',
      name: 'from_date',
      id: 'exportDatepickerFrom',
      value: params?.from,
    },
    {
      label: 'To',
      name: 'to_date',
      id: 'exportDatepickerTo',
      value: params?.to,
    },
    {
      label: 'Status',
      name: 'include_statuses',
      title: 'Statuses',
      id: 'exportStatusesDropdown',
      allSelected: true,
      toolbarClass: 'export__empty-dropdown',
    },
    {
      isButton: true,
    },
  ];

  if (from || to) {
    return elements.slice(from, to);
  }
  return elements;
};

export const generateTableHead = (accessExport) => {
  if (!accessExport) {
    return ['From', 'To', 'Status', 'Format', 'Created'];
  }

  return ['From', 'To', 'Status', 'Format', 'Created', ''];
};

export const makeTableRow = (item) => {
  const tableRow = [item.from_date, item.to_date, item.status, item.format, item.date, item.id];

  return tableRow;
};

export const parseValues = (values, statuses, include) => {
  const parsedStatuses = statuses
    .filter((el) => values?.include_statuses?.includes(el.title))
    .map((el) => +el.id);

  return {
    ...values,
    include_statuses: parsedStatuses,
    include_columns: include?.map((item) => item.id),
  };
};
